module.exports = __webpack_public_path__ + "static/media/pills2.3e6683e8.png";